<template>
  <VpShell :aside="false">
    <VpFeature the-key="WHATSAPP_BROADCAST_TEMPLATE" #default="{ feature }">
      <RouterView :feature="feature" />
    </VpFeature>
  </VpShell>
</template>

<script>
export default {};
</script>
